//CRIANDO ACTION

import { createAction, props } from '@ngrx/store';
import { IProfessional } from 'src/app/shared/interfaces/professional/iprofessional';

//padrão de nomenclatura tudo maiusculo
enum ProfessionalActionType {
  //textos para acomparnharmos os estados de load professional
  LOAD_PROFESSIONAL = '[professional] load professional from api',
  LOAD_PROFESSIONAL_SUCCESS = '[professional] load professional from api return success',
  LOAD_PROFESSIONAL_ERROR = '[professional] load professional from api return error',
  SAVE_PROFESSIONAL = '[professional] save professional from api',
  SAVE_PROFESSIONAL_SUCCESS = '[professional] save professional from api return success',
  SAVE_PROFESSIONAL_ERROR = '[professional] save professional from api return error',
  EDIT_PROFESSIONAL = '[professional] edit professional from api',
  EDIT_PROFESSIONAL_SUCCESS = '[professional] edit professional from api return success',
  EDIT_PROFESSIONAL_ERROR = '[professional] edit professional from api return error',
  DELETE_PROFESSIONAL = '[professional] delete professional from api',
  EDIT_PROFESSIONAL_CURRENT_ID = '[professional] edit professional current id',
  DELETE_CURRENT_PROFESSIONAL = '[professional] delete current professional',
  RESET_PROFESSIONAL_STATE = '[professional] Reset State'
}

export const resetProfessionalState = createAction(
  ProfessionalActionType.RESET_PROFESSIONAL_STATE
);

export const loadProfessional = createAction(
  ProfessionalActionType.LOAD_PROFESSIONAL
);
export const loadProfessionalSuccess = createAction(
  ProfessionalActionType.LOAD_PROFESSIONAL_SUCCESS,
  props<{ lista: IProfessional[] }>()
);
//vai para o effects
export const saveProfessional = createAction(
  ProfessionalActionType.SAVE_PROFESSIONAL,
  props<{ professional: IProfessional }>()
);
//vai para o reducer
export const saveProfessionalSuccess = createAction(
  ProfessionalActionType.SAVE_PROFESSIONAL_SUCCESS,
  props<{ professional: IProfessional }>()
);

export const saveProfessionalError = createAction(
  ProfessionalActionType.SAVE_PROFESSIONAL_ERROR,
  props<{error: any}>()
);

//vai para o effects
export const editProfessional = createAction(
  ProfessionalActionType.EDIT_PROFESSIONAL,
  props<{ professional: IProfessional; id: number }>()
);
//vai para o reducer
export const editProfessionalSuccess = createAction(
  ProfessionalActionType.EDIT_PROFESSIONAL_SUCCESS,
  props<{ professional: IProfessional }>()
);

export const editProfessionalError = createAction(
  ProfessionalActionType.EDIT_PROFESSIONAL_ERROR,
  props<{ description: string }>()
);

export const deleteProfessional = createAction(
  ProfessionalActionType.DELETE_PROFESSIONAL,
  props<{ id: any }>()
);

export const editCurrentProfessional = createAction(
  ProfessionalActionType.EDIT_PROFESSIONAL_CURRENT_ID,
  props<{ professional: any }>()
);

export const deleteCurrentProfessional = createAction(
  ProfessionalActionType.DELETE_CURRENT_PROFESSIONAL
);

